import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    wordsPerInch: 0,
    masterTemplate: false,
    hotQueues: false,
    perPageDefault: 0,
    fetchInitiated: false
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/settings')
        .then(response => {
          const settings = response.data.settings

          this.wordsPerInch = settings.words_per_inch
          this.masterTemplate = settings.master_template
          this.hotQueues = settings.hot_queues
          this.perPageDefault = settings.per_page_default
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    },

    setWordsPerInch(value) {
      this.wordsPerInch = value
    },

    setMasterTemplate(value) {
      this.masterTemplate = value
    },

    setHotQueues(value) {
      this.hotQueues = value
    },

    setPerPageDefault(value) {
      this.perPageDefault = value
    }
  }
})